import { LanguageSwitcher } from "@/components/common";
import { ThemeSwitcher } from "@/components/layout";
import { useTran } from "@/hooks";
import { cn } from "@/lib/utils";

const AuthStandaloneShell = ({ children, className, contentClassName }) => {
  const { t } = useTran();

  return (
    <div className="relative min-h-screen min-h-[100dvh] overflow-hidden bg-background">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,hsl(var(--primary)/0.14),transparent_34%),radial-gradient(circle_at_bottom_right,hsl(var(--secondary)/0.14),transparent_32%)]" />

      <div className="absolute left-4 top-4 z-20 sm:left-6 sm:top-6">
        <img
          src="/logos/logo.svg"
          alt={t("NxStart Logo")}
          className="h-10 w-auto sm:h-12"
        />
      </div>

      <div className="absolute right-4 top-4 z-20 flex items-center gap-2 sm:right-6 sm:top-6">
        <LanguageSwitcher />
        <ThemeSwitcher />
      </div>

      <div
        className={cn(
          "relative z-10 mx-auto flex min-h-screen min-h-[100dvh] w-full items-center justify-center px-4 pb-8 pt-24 sm:px-6 sm:pb-10 sm:pt-28",
          contentClassName,
        )}
      >
        <div
          className={cn(
            "w-full max-w-md rounded-[28px] border border-border/80 bg-card/95 p-5 shadow-2xl backdrop-blur sm:p-8",
            className,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthStandaloneShell;
